export default "__VITE_ASSET__jKZqNkWq__"